export default "__VITE_ASSET__927c58df__"